import { render, staticRenderFns } from "./ClientInfoBonuses.vue?vue&type=template&id=12da9ba0&scoped=true"
import script from "./ClientInfoBonuses.vue?vue&type=script&lang=js"
export * from "./ClientInfoBonuses.vue?vue&type=script&lang=js"
import style0 from "./ClientInfoBonuses.vue?vue&type=style&index=0&id=12da9ba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12da9ba0",
  null
  
)

export default component.exports